/** @format */

import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useGlobal } from 'reactn';
import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import Spacer from '../../../../../../components/Commons/Spacer';
import CustomButton from '../../../../../../v2-components/Antd/Button';
import './style.scss';
import { GlobalConsumer } from '../../../../../../components/Commons/Context/Global';

export default function CheckoutButtonRetirement(props) {
	const [isLoading] = useGlobal('retirementButtonLoading');
	const [isRecalculatingDelivery] = useGlobal('isRecalculatingDelivery');
	const [isMobile, setMobile] = useState(false);
	const { isSelectionRetirementType, setSelectionRetirementError } = GlobalConsumer();
	const [isAddressValidated] = useGlobal('isAddressValidated');
	// eslint-disable-next-line
	const [isDirectionValidation, setDirectionValidation] = useGlobal('directionValidation');
	

	useEffect(() => {
		if (window.innerWidth < 992) {
			setMobile(true);
		}
	}, []);

	const buttonClass = props.type === 'retirement' && !isMobile ? 'ph-checkout-withdrawal-button-full' : 'button-primary';

	const handleTypeError = () => {
		if (isSelectionRetirementType === null) {
			setSelectionRetirementError(true);
		}

		if (isSelectionRetirementType === 'delivery' && !isAddressValidated) { 
			setDirectionValidation(true);
		}

		// on mobile, scroll to the first visible validation message
		if (isMobile) {
			const selector = '.ant-form-item-explain.ant-form-item-explain-error, .ph-bag-address-text-error, .ph-checkout-type-delivery-card-footer-advertise-validation, .ph-bag-recipes-info-upload-subtitle, .ph-check-recipe-cart p';
			const timeout = 1500;
			const interval = 100;
			const start = Date.now();
			const tryFind = () => {
				const errors = document.querySelectorAll(selector);
				if (errors && errors.length > 0) {
					const list = Array.from(errors).map((el) => ({ el, y: el.getBoundingClientRect().top + window.pageYOffset }));
					list.sort((a, b) => a.y - b.y);
					const first = list[0];
					try {
						if (first && first.el && first.el.scrollIntoView) {
							first.el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
						} else {
							const top = first.el.getBoundingClientRect().top + window.pageYOffset;
							const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
							window.scrollTo({ top: target, behavior: 'smooth' });
						}
					} catch (e) {
						const top = first.el.getBoundingClientRect().top + window.pageYOffset;
						const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
						window.scrollTo({ top: target, behavior: 'smooth' });
					}
					const input = first.el.closest('.ant-form-item')?.querySelector('input, textarea, select, .ant-select');
					if (input) try { input.focus(); } catch (e) {}
					return;
				}
				if (Date.now() - start < timeout) setTimeout(tryFind, interval);
			};
			tryFind();
		}
	};

	return (
		<Form.Item className="ph-checkout-withdrawal-button-main-container">
			{isMobile && !isRecalculatingDelivery && (
				<>
					<div>
						<h3 className="ph-checkout-withdrawal-button-mobile-price-main-title">Total a pagar:</h3>
						<h3 className="ph-checkout-withdrawal-button-mobile-price-title">
							<span className="ph-checkout-withdrawal-button-mobile-price-description">$</span>
							{props.item.total}
						</h3>
					</div>
					<Spacer />
				</>
			)}
			<CustomButton className={buttonClass} loading={isLoading || isRecalculatingDelivery} disabled={isRecalculatingDelivery} htmlType={'submit'} onClick={handleTypeError}>
				{Enviroment.ROOT_RESERVE ? 'CONSULTAR STOCK' : 'Siguiente'}
			</CustomButton>
		</Form.Item>
	);
}
